import { Component, Input, TemplateRef } from '@angular/core';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams } from 'ag-grid-community';

@Component({
  selector: 'app-popover-info',
  standalone: true,
  imports: [NgbPopoverModule],
  templateUrl: './popover-info.component.html',
  styleUrl: './popover-info.component.scss'
})
export class PopoverInfoComponent implements IHeaderAngularComp  {
  public params!: IHeaderParams & {
    title: string;
    contentHtml: string;
    iconClass: string;
    popoverClass: string;
    placement: 'top' | 'bottom' | 'left' | 'right';
    trigger: string;
  };

  @Input() template?: TemplateRef<any>; // optional custom template
  @Input() trigger: string = 'manual'; // default hover
  @Input() placement: 'top' | 'bottom' | 'left' | 'right' = 'top';
  @Input() popoverClass: string = '';

  agInit(params: IHeaderParams | any): void {
    this.params = params;
  }

  refresh(): boolean {
    return false;
  }

  togglePopover(popover: any) {
    popover.isOpen() ? popover.close() : popover.open();
  }


}
